export default __webpack_public_path__ + "24e7f6b40c6247360e13b12a9bfccaa5.woff";